import { Box } from '@mui/material'
import styles from './CollapsibleNavSection.module.scss'

export default function NavSectionHeader({ title, actions }) {
  return (
    <Box className={styles.headerRow}>
      <Box className={`${styles.headerToggle} ${styles.headerStatic}`}>
        <Box component="span" className={styles.title}>
          {title}
        </Box>
      </Box>
      {actions ? <Box className={styles.headerActions}>{actions}</Box> : null}
    </Box>
  )
}
